import { DynamicField } from "./dynamic-field.model";
import { Observable } from "rxjs";
import { AsyncValidatorFn, ValidatorFn } from "@angular/forms";

export class DynamicInput<T> extends DynamicField<T> {
    mask?: false | (string | RegExp)[] | ((raw: string) => (string | RegExp)[]);
    pattern?: string | RegExp;
    patternProperty!: keyof T;
    icon?: string;
    maxLength?: number;
    hasLettersNumbers?: boolean;
    passwordFeedback?: boolean;
    passwordToggleMask?: boolean;
    inputType?: 'text' | 'tel' | 'email' | 'number';
    helperText?: string;
    helpLink?: string;
    hiddenValidationsObserver?: Observable<boolean>;

    constructor(source: Partial<DynamicInput<T>>) {
        super();
        this.inputType = 'text';
        this.placeholder = '';
        this.maxLength = 200;
        this.mask = false;
        this.pattern = '';
        Object.assign(this, source);

        if(this.disabled) {
            this.formControl?.disable();
        }

        this.disabledObserver?.subscribe(value => {
            this.disabled = value;

            this.disabled ? this.formControl?.disable() : this.formControl?.enable();
        });

        this.hiddenValidationsObserver?.subscribe(value => {
            if (!value) {
                this.setFieldValidations();
            } else {
                this.formControl?.setAsyncValidators(null);
                this.formControl?.setValidators(null);
                this.formControl?.updateValueAndValidity();
            }
        });
    }


    /**
     * The function sets the validators and async validators for a form control.
     */
    private setFieldValidations() {

        let validators: (ValidatorFn)[] | undefined = this.validators?.map(item => item.validator);
        let asyncValidators: (AsyncValidatorFn)[] | undefined = this.validators?.map(item => item.asyncValidator);

        if (validators) {
            this.formControl?.setValidators(validators);
        }

        if (asyncValidators && !asyncValidators.some(item => item === undefined)) {
            this.formControl?.setAsyncValidators(asyncValidators);
        }
    }

}